import angular from 'angular';
import kendo from '@progress/kendo-ui';

angular.module('webTools').directive('wtPathSelect', ['$compile', '$document', '$timeout',
    function($compile, $document, $timeout) {
        return {
            restrict: 'E',
            replace: true,
            transclude: false,
            scope: {
                model: '=',
                allowEdit: '='
            },
            template: '<div class="wt-path-select">' +
                        '<div class="path-button">' +
                            '<Icon type="\'folder\'" fa-style="\'fas\'"></Icon>' +
                        '</div>' +
                        '<span class="path-overlay" ng-hide="allowEdit"></span>' +
                        '<input ng-model="model"></input>' +
                      '</div>',
            link: function(scope, element, attributes) {

                //scope.model = '';

                element.on('click', function() {
                    window.launchLegacyDialog('select-path');
                });

                scope.setPath = function(path) {
                    scope.$apply(function() { scope.model = path; });
                };

                var timer;
                var tooltipElement = '';

                element.bind('mouseover', function() {

                    tooltipElement = $compile('<div class="popover hidden">' +
                                                '<div class="popover-content">' +
                                                    scope.model +
                                                '</div>' +
                                                '</div>')(scope);

                    $document.find('body').append(tooltipElement);

                    var position = element.offset();

                    var el = tooltipElement;

                    el.css({ 'left': position.left + 25, 'top': position.top + 1 });

                    var effect = kendo.fx(el).fadeIn().duration(700);

                    timer = $timeout(function() { effect.play() }, 500);
                });

                element.bind('mouseout', function() {
                    tooltipElement.remove();
                });

                element.bind('click', function() {
                    tooltipElement.remove();
                });

                scope.$on('$destroy',
                    function(event) {
                        $timeout.cancel(timer);
                    }
                );
            }
        };
    }
]);